//
// Module for the Account Transactions - Add - Salary grid partial view
//
rs.module("content/participant/member/accounttransactions/salarygrid",

    [ /* dependencies */ ],

    function () {

        // Initialize the module
        function initialize(salaryGrid, jsSelectors) {
            var addSalaryLink = $.js(jsSelectors.addSalaryLink);

            addSalaryLink.on("click", function () {
                salaryGrid.addRow();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);